export { default as DynamicThemingButton } from './dynamic-theming-button';
